import { configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./reducers/user";
import { sellerReducer } from "./reducers/seller";
import { productReducer } from "./reducers/product";
import { cartReducer } from "./reducers/cart";
import { wishlistReducer } from "./reducers/wishlist";
import { orderReducer } from "./reducers/order";

// Get preloaded state from SSR or sessionStorage
const getPreloadedState = () => {
  // First check for SSR state (for bots)
  if (typeof window !== 'undefined' && window.__INITIAL_DATA__) {
    return window.__INITIAL_DATA__;
  }
  
  // For normal users, check sessionStorage for persisted auth state
  if (typeof window !== 'undefined') {
    try {
      const persistedAuth = sessionStorage.getItem('authState');
      
      // Always restore pinCode and coordinates from localStorage
      const pinCode = localStorage.getItem('userPinCode') || null;
      const coordinates = localStorage.getItem('userCoordinates')
        ? JSON.parse(localStorage.getItem('userCoordinates'))
        : null;
      
      if (persistedAuth) {
        const authState = JSON.parse(persistedAuth);
        return {
          user: {
            ...authState.user,
            pinCode,
            coordinates,
          },
          seller: authState.seller || undefined,
        };
      } else if (pinCode || coordinates) {
        // Even without auth state, preserve pinCode and coordinates
        return {
          user: {
            pinCode,
            coordinates,
          },
        };
      }
    } catch (e) {
      console.error('Failed to load persisted auth state:', e);
    }
  }
  
  return undefined;
};

const Store = configureStore({
  reducer: {
    user: userReducer,
    seller: sellerReducer,
    products: productReducer, 
    cart: cartReducer,
    wishlist: wishlistReducer,
    order: orderReducer,
  },
  preloadedState: getPreloadedState(),
});

// Persist authentication state to sessionStorage for fast reload
if (typeof window !== 'undefined') {
  Store.subscribe(() => {
    const state = Store.getState();
    try {
      const authState = {
        user: {
          isAuthenticated: state.user?.isAuthenticated,
          user: state.user?.user,
        },
        seller: {
          isAuthenticated: state.seller?.isAuthenticated,
          seller: state.seller?.seller,
        },
      };
      sessionStorage.setItem('authState', JSON.stringify(authState));
    } catch (e) {
      console.error('Failed to persist auth state:', e);
    }
  });
}

export default Store;

 